import classNames from 'classnames';
import { ComponentProps, useContext } from 'react';

import Button from '../Button/Button';
import FormContext from '../Form/FormContext';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';

import useDebouncedLoading from './useDebouncedLoading';

import styles from './SubmitButton.module.css';

type SubmitButtonProps = { loading?: boolean } & ComponentProps<typeof Button>;

const SubmitButton = ({
    children,
    loading = false,
    disabled,
    type = 'submit',
    ...buttonProps
}: SubmitButtonProps) => {
    const { submitting, disabled: formDisabled } = useContext(FormContext);
    const submittingOrLoading = submitting || loading;
    const showSpinner = useDebouncedLoading(submittingOrLoading);

    return (
        <Button
            {...buttonProps}
            className={classNames(styles.Root, buttonProps.className)}
            type={type}
            disabled={showSpinner || disabled || formDisabled}
        >
            <span
                className={classNames(styles.Label, {
                    [styles.Label_loading]: showSpinner,
                })}
            >
                {children}
            </span>

            <span
                className={classNames(styles.Spinner, {
                    [styles.Spinner_visible]: showSpinner,
                })}
            >
                {showSpinner && <LoadingSpinner color="disabled" />}
            </span>
        </Button>
    );
};

export default SubmitButton;
